export enum ProductTypeEnum {
  STANDARD = 'STANDARD',
  SCION = 'SCION',
  STOCK = 'STOCK',
}

export const ProductTypeMapping = {
  [ProductTypeEnum.STANDARD]: 'Pé franco',
  [ProductTypeEnum.SCION]: 'Enxerto',
  [ProductTypeEnum.STOCK]: 'Porta-enxerto',
};
